module.exports = __webpack_public_path__ + "img/blue-search.e9d66dad.svg";